import PlayerUi, { PlayerUiProps } from './PlayerUi';

export default PlayerUi;
export type { PlayerUiProps };
